import React, {useRef} from 'react';
import {Charts} from "./charts";
import {TableMarketplaces} from "./tableMarketplaces";
import {Button} from "antd";

import styles from './content.module.sass'
import {ExportCSV} from "../../utils/exportToCSV";
import {useAppDispatch, useAppSelector} from "../../redux/store";
import {
    choiceOfPlatform,
    loadingTables,
    selectCategory,
    selectChart, selectHidden,
    selectSwitchCategories, selectTableChartCategories,
    setTable,
    visiblePDF, visTable
} from "../../common/selectors";
import {ChartsButtons} from "./charts/chartsButtons";
import {Spinner} from "../../common/spin";
import {visiblePDFAC} from "../../redux/optionsReducer";
import {TimeLineChart} from "./timeLineChart";
import {useReactToPrint} from "react-to-print";
import {TableSupermarkets} from "./tableSupermarkets";
import {SettingForTable} from "../options/settingForTable";
import {TimeLineChart1} from "./timeLineChart/timeLineChart1";
import cn from 'classnames'
import {NewsComponent} from "../newsComponent";

// Компонент контента страницы, отвечает за отображение графиков, таблиц, кнопок и экспорт
export const Content = () => {
    // Получаем выбранную платформу (marketplaces/supermarkets/stocks/price)
    const platform = useAppSelector(choiceOfPlatform)
    // Получаем выбранный график
    const chart = useAppSelector(selectChart)
    // Получаем выбранную категорию
    const category = useAppSelector(selectCategory)
    // Получаем статус загрузки таблиц
    const loadingForTables = useAppSelector(loadingTables)
    // Получаем выбранные категории для переключателя
    const categories = useAppSelector(selectSwitchCategories)
    // Получаем состояние отображения таблицы
    const table = useAppSelector(setTable)
    // Получаем состояние видимости PDF
    const visible = useAppSelector(visiblePDF)
    // Получаем состояние скрытия графика
    const hidden = useAppSelector(selectHidden)
    // Получаем состояние видимости таблицы
    const visibleTable = useAppSelector(visTable)
    // Получаем состояние отображения таблицы по категориям графика
    const tableChartsCategories = useAppSelector(selectTableChartCategories)

    // Получаем dispatch для работы с redux
    const dispatch = useAppDispatch()

    // Ссылка на DOM-элемент для печати
    const componentRef = useRef(null);
    // Обработчик печати PDF
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        onAfterPrint: () => {
            dispatch(visiblePDFAC(true));
        }
    });

    // Обработчик скрытия PDF после печати
    const onMouseDown = () => dispatch(visiblePDFAC(false))

    // ...рендер...
    return (
        <div className={styles.main} ref={componentRef} >
            {/* Основной контент: графики, таблицы, кнопки */}
            <div className={styles.content}>
                {/* Блок с графиком */}
                <div className={cn(styles.charts, hidden&&styles.hiddenChart)}><Charts/></div>
                {/* Кнопки управления графиком */}
                <div style={{opacity: visible?1:0}}><ChartsButtons/></div>
                {platform==='stocks'&&<SettingForTable buttonName={category === 'marketplaces' ? 'по маркетплейсам' : 'по супермаркетам'}/>}
                {!table&&window.innerWidth > 1000 && visibleTable && platform !== "price"  && !tableChartsCategories && (loadingForTables==='loading' && !categories ? <Spinner/> : <TimeLineChart1/>)}
                {/* Таблица или спиннер при загрузке, если выбрана таблица */}
                {table && visibleTable && (loadingForTables==='loading' ? <Spinner/> : !categories && (category === 'marketplaces' ? <TableMarketplaces/> : (category === 'supermarkets'&& <TableSupermarkets/>)))}
            </div>
            {/* Кнопки печати PDF и экспорта CSV (скрыты по умолчанию) */}
            <div style={{
                display: 'none',
                justifyContent: "flex-end",
                marginTop: 20,
                marginBottom: 40,
                opacity: visible ? 1 : 0
            }}>
                <Button onClick={handlePrint} onMouseUp={onMouseDown}
                        style={{borderRadius: 5, backgroundColor: '#0A6C87', color: 'white'}}>Печать PDF</Button>
                <ExportCSV/>
            </div>
        </div>
    );
};
// ...конец файла...
